import { CHANNEL_ACTIONS, CHANNEL_ACTION_TYPES } from "../actions/channels"
import { apiStatusInitialState, apiStatusStateType } from "../misc"
import { ChannelType } from "../../Channel/ChannelDataTypes"
import produce, { enableES5} from "immer"

enableES5();

export type ChannelStateType = {
  data: ChannelType[]
  activeChannel: ActiveChannelType
  fetchStatus: apiStatusStateType
}

export type ChannelFilterType = {
  favorites?: boolean,
  recent?: boolean
}

export type ActiveChannelType = {
  channelId?: number,
  centroidId?: number,
  familyTag?: string | ""
  filters?: ChannelFilterType
}

export const initialState: ChannelStateType = {
  data: [],
  activeChannel: {},
  fetchStatus: apiStatusInitialState
}

export default (state = initialState, action: CHANNEL_ACTION_TYPES): ChannelStateType => {

  switch (action.type) {
    case CHANNEL_ACTIONS.FETCH_CHANNELS_START:
      return {
        ...state,
        fetchStatus: {
          ...state.fetchStatus,
          loading: true,
        }
      }
    case CHANNEL_ACTIONS.FETCH_CHANNELS_SUCCESS:
      if (action.payload) {
        return {
          ...state,
          data: action.payload,
          fetchStatus: {
            ...state.fetchStatus,
            lastFetch: Date.now(),
            errorCode: null,
            developerMessage: null,
            userMessage: null,
            moreInfo: null,
            lastError: null,
            loading: false
          }
        }
      }
      // caution: break is omitted intentionally if the payload is falsey

    case CHANNEL_ACTIONS.FETCH_CHANNELS_ERROR:
      return {
        ...state,
        fetchStatus: {
          ...state.fetchStatus,
          ...action.error,
          lastError: Date.now(),
          loading: false
        }
      }
    case CHANNEL_ACTIONS.ACTIVE_CHANNEL_SET:
      return {
        ...state,
        activeChannel: action.payload
      }
    case CHANNEL_ACTIONS.ALERT_ADDED:
      return {
        ...state,
        data: produce(state.data, (draft) => {
          const channelIndex = draft.findIndex(channel => channel.id === action.payload.board.id);

          draft[channelIndex].alerts.push({
            id: action.payload.id,
            message: action.payload.message,
            expires: action.payload.expires,
            cell: {
              id: action.payload.cell.id,
              title: action.payload.cell.title
            }
          })
        })
      }
    default:
      return state
  }
}